import { render } from "./Tab1.vue?vue&type=template&id=897bfa3c&scoped=true"
import script from "./Tab1.vue?vue&type=script&lang=js"
export * from "./Tab1.vue?vue&type=script&lang=js"

import "./Tab1.vue?vue&type=style&index=0&id=897bfa3c&scoped=true&lang=css"

import exportComponent from "/Users/brianng/Desktop/supaionic/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897bfa3c"]])